import { render, staticRenderFns } from "./CustomSplashscreen.vue?vue&type=template&id=27a257c7&"
import script from "./CustomSplashscreen.vue?vue&type=script&lang=js&"
export * from "./CustomSplashscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports